import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

export const ConfirmReplaceSignatoryModal = ({
  open,
  onClose,
  onConfirm,
  currentSignatoryName,
  newSignatoryName,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentSignatoryName: string;
  newSignatoryName: string;
}) => {
  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size="small">
        <StatusModal type="warning" title="Replace authorized signatory?">
          This company can only have one authorized signatory at a time.
          Continuing will replace {currentSignatoryName} with {newSignatoryName}
          .
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Button type="button" onClick={onClose}>
            Go back
          </Button>
          <Button customType="primary" onClick={onConfirm}>
            Yes, replace
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
